import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";

const RouteErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : "The page could not be loaded. Reload the application to try again.";

  return (
    <main role="alert" aria-labelledby="route-error-heading">
      <h1 id="route-error-heading">Something went wrong.</h1>
      <p>{detail}</p>
    </main>
  );
};

export { RouteErrorBoundary };
